import React, { Component } from 'react';
import { Text as NativeText, View } from 'react-native';

import Text from './text';
import { getProps, getFontSize, getStyles } from './utils';

class ResponsiveText extends Component {
  constructor(props) {
    super(props);

    this.state = {
      measured: false,
      fontSize: null,
    };

    this.handleMeasureLayout = this.handleMeasureLayout.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.children !== this.props.children ||
        nextProps.size !== this.props.size ||
        nextProps.minSize !== this.props.minSize) {
      this.setState({
        measured: false,
      });
    }
  }

  handleMeasureLayout({ nativeEvent }) {
    if (!nativeEvent.layout.height) {
      return;
    }

    const textHeight = nativeEvent.layout.height;
    const fontSize = getFontSize(this.props);
    const numberOfLines = this.props.numberOfLines || 1;

    if (textHeight < fontSize * (numberOfLines + 1)) {
      this.setState({
        measured: true,
        fontSize,
        size: this.props.size,
      });

      return;
    }

    const minFontSize = getFontSize({
      ...this.props,
      size: this.props.minSize,
    });

    this.setState({
      measured: true,
      fontSize: minFontSize,
      size: this.props.minSize,
    });
  }

  render() {
    const { children } = this.props;
    const { fontSize, measured, size } = this.state;

    const styles = getStyles(this.props);
    let text;

    if (measured) {
      const textStyle = [styles, {
        lineHeight: fontSize,
        marginTop: fontSize / 2,
      }];

      text = (
        <Text
          {...getProps(this.props)}
          size={size}
          style={textStyle}
        >
          {children}
        </Text>
      );
    } else {
      const measureFontSize = getFontSize(this.props);
      const measureStyle = [styles, {
        opacity: 0,
        lineHeight: measureFontSize,
        fontSize: measureFontSize,
      }];
      text = (
        <NativeText
          allowFontScaling={false}
          style={measureStyle}
          onLayout={this.handleMeasureLayout}
        >
          {children}
        </NativeText>
      );
    }

    return (
      <View>
        {text}
      </View>
    );
  }
}

ResponsiveText.propTypes = {
  ...Text.propTypes,
  minSize: Text.propTypes.size,
};

ResponsiveText.defaultProps = {
  ...Text.defaultProps,
  minSize: 'small',
};

export default ResponsiveText;
